import React, {useEffect, useState} from 'react';
import './PickHourlySlide.css';
import ProgressMeter from "../ProgressMeter/ProgressMeterTutor";
import pickHourAnimation from "../../../../../assets/json/pick-hour.json";
import Lottie from "react-lottie";
import { resolveTutorHomeAsset, globalText } from '../tutorHomeConfig';

function PickHourlySlide({hourData, config = {}}){
    const [count, setCount] = useState(null);
    const [isDayTime, setIsDayTime] = useState(false);
    let endTime = null;

    useEffect(() => {
        if (hourData?.endTime) {
            hourData.endTime.forEach((item) => {
                if (item !== null) {
                    endTime = item;
                }
            });
            if (endTime > 36000) {
                setIsDayTime(true);
            } else {
                setIsDayTime(false);
            }
            setCount(endTime);
        }
        const intervalId = setInterval(() => {
            setCount(prevCount => {
                if (prevCount <= 0) {
                    clearInterval(intervalId);
                    return 0;
                }
                return prevCount - 1;
            });
        }, 1000);
        return () => clearInterval(intervalId);
    }, [hourData]);

    const formatTime = (seconds) => {
        const hrs = Math.floor(seconds / 3600);
        const mins = Math.floor((seconds % 3600) / 60);
        const secs = seconds % 60;
        return `${String(hrs).padStart(2, '0')}:${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
    };

    const pickHourAnimationLottie = {
        loop: true,
        autoplay: true,
        animationData: pickHourAnimation,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
        },
    };

    return(
        <div className="slideCard slideCardPickHour">
            <div className="cardBody" style={config.images?.card_background ? {'--tutor-home-card-background': `url("${resolveTutorHomeAsset(config.images.card_background)}")`} : undefined}>

            <div className="body-card-inner">
                  <img src={resolveTutorHomeAsset(config.images?.header_artwork)} alt="signature"/>
			</div>
{/* 
                {isDayTime ?
                    <img className="hourly-top-img" src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/repl-25-pick-day-top-title.png" alt="img"/> :
                    <img className="hourly-top-img" src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/repl-25-pick-hour-top-title.png" alt="img"/>
                } */}
                <hr className="img-border" />
                <div className="revenueFlex">
                    <div className="revenueData">
						<img src={resolveTutorHomeAsset(config.images?.revenue_divider || 'https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/rep-25-slide-1-pipe-img.png')} alt="border" height={50} width={4} />
                        <div>
                            <h4>{globalText.revenue_label || 'Your Revenue'}</h4>
                            <h1>{hourData?.total}</h1>
                        </div>
                    </div>
                    <div className="btnTimeRemain">
                        {config.text?.countdown_label || 'ends in:'} <span>{formatTime(count)}</span>
                    </div>
                </div>
                <div className="meterData">
                    <ProgressMeter width={hourData?.progressBar || 50}/>
                </div>
                <div className="goalComplete">
                    <p className="text-compete">{hourData?.progressBar}{config.text?.progress_suffix || '% complete'}</p>
                    <p className="text-goal">{globalText.goal_prefix || 'Goal:'} {hourData?.goal}</p>
                </div>
                <div className="prizeBox">
					<img src={resolveTutorHomeAsset(config.images?.prize_artwork || 'https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/repl-25-pick-hour-slide-img2.png')} alt="img"/>
                    {/*<span className="overlayDark" style={{ width: 100 - hourData?.progressBar+'%' }}></span>*/}
                </div>
            </div>
        </div>
    )
}

export default PickHourlySlide;
